import { isFulfilled } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../app/hooks";
import { fetchOrderTemplates } from "../../../../../features/customer/orderTemplatesSlice";
import { OrderRowTemplateOption } from "./types";

type Props = {
  contractId?: string;
};

/**
 * Hook for fetching order row templates by contract ID.
 *
 * Note: No autocomplete query implemented in backend.
 * Fetches all templates for the given contract and filters/sorts client-side.
 */
const useOrderRowTemplateAutocomplete = ({ contractId }: Props) => {
  const [orderRowTemplateOptions, setOrderRowTemplateOptions] = useState<
    OrderRowTemplateOption[]
  >([]);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (contractId) {
      dispatch(fetchOrderTemplates({ contractId })).then((action) => {
        if (isFulfilled(action)) {
          const options: OrderRowTemplateOption[] = action.payload
            .filter((template) => template.active)
            .map((template) => ({
              id: template.id,
              name: template.name,
              workTitleId: template.workTitleId,
              active: template.active,
            }))
            .sort((a, b) => a.name.localeCompare(b.name, "fi"));

          setOrderRowTemplateOptions(options);
        }
      });
    } else {
      setOrderRowTemplateOptions([]);
    }
  }, [contractId, dispatch]);

  // Auto-reset when contractId changes
  useEffect(() => {
    setOrderRowTemplateOptions([]);
  }, [contractId]);

  return {
    orderRowTemplateOptions,
  };
};

export default useOrderRowTemplateAutocomplete;
